import { Component } from '@angular/core';
import { Action } from '@kaiser-software/chassis-datatable';

@Component({
    selector: 'chassis-datatable-delete-action',
    templateUrl: './delete.component.html',
    styleUrls: ['./delete.component.scss'],
})
export class DeleteComponent extends Action {

    public delete(): void {
        const prompt = window.confirm('Are you sure?');

        prompt
            ? this.sendDeleteRequest()
            : this.cancel();
    }

    protected sendDeleteRequest(): void {
        console.log('Send delete request');
    }

    protected cancel(): void {
        console.log('Cancel');
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/actions/delete/delete.component.ts